import clsx from "clsx";
import { twMerge } from "tailwind-merge";

interface RadioProps extends React.ComponentProps<"input"> {
  option?: boolean;
}

export function Radio({ children, className, option = false, ...props }: RadioProps) {
  return (
    <label
      className={twMerge(
        clsx(
          "flex gap-x-1.5 items-center cursor-pointer has-disabled:cursor-not-allowed",
          "text-neutral-600 dark:text-neutral-400 transition-all",
          className,
        ),
      )}
    >
      <span
        className={clsx(
          "relative grid size-5 shrink-0 place-items-center",
          "rounded-full inset-ring inset-ring-neutral-300 bg-white",
          "dark:inset-ring-neutral-700 dark:bg-neutral-900",
          "has-checked:inset-ring-2 cursor-pointer",
          "has-checked:inset-ring-blue-500 has-checked:bg-blue-500",
          "has-disabled:opacity-50",
          {
            "has-focus-visible:outline-2 has-focus-visible:outline-offset-2": !option,
            "has-focus-visible:outline-blue-500": !option,
          },
        )}
      >
        <input
          type="radio"
          className="peer absolute inset-0 m-0 appearance-none
                     focus-visible:outline-none cursor-pointer"
          {...props}
        />
        <div
          className="pointer-events-none size-4 rounded-full border-2
                     peer-checked:border-white
                     peer-checked:dark:border-neutral-900 opacity-0
                     peer-checked:opacity-100"
        />
      </span>
      {children}
    </label>
  );
}

export function Option({ children, ...props }: React.ComponentProps<"input">) {
  return (
    <Radio
      className="p-2 pr-3 rounded-full inset-ring inset-ring-neutral-300 dark:inset-ring-neutral-700
                 w-fit has-checked:inset-ring-blue-500 has-checked:text-blue-500
                 has-checked:inset-ring-2 hover:shadow-md shadow-black/5 dark:shadow-black/30
                 has-focus-visible:outline-2 has-focus-visible:outline-offset-2
                 has-focus-visible:outline-blue-500"
      option
      {...props}
    >
      <span className="font-medium text-sm">{children}</span>
    </Radio>
  );
}
